<template>
	<div class="relative ff2 footer p-5 text-white" style="background-color: #7A634E;">
		<div v-if="sm" class="main">
			<div class=" relative">
				<img src="@/assets/logo_x.png" style="width:150px;" />
			</div>
			<hr class="my-2 bg-gray" />
			<div class="relative f fx cml-2">

				<div class="f-2 relative cmt-1">
					<div class="relative f16 bolder mb-3">
						{{$t('saima.f2')}}
					</div>
					<div class="relative f10">
						{{$t('saima.f1')}}
					</div>
					<div class="relative f10 ">
						<a class="text-white" href="mailto:growth@emoka.co">growth@emoka.co</a>
					</div>
				</div>
				<div class="f-1 relative cmt-1">
					<div class="relative f16 bolder">
						{{$t('saima.f3')}}
					</div>
					<div class="relative f10 mt-3">
						<a href="https://www.instagram.com/emokaglobal" target="_blank">
							<img src="@/assets/f1.png" style="width: 48px;" />
						</a>
					</div>

				</div>
			</div>



			<div class="relative f10 mt-5">
				<div class="f-1 relative">
					Copyright © 2025 EMOKA
				</div>

			</div>
		</div>
		<div v-else class="main">
			<div class="relative f fx">
				<div class="f-1 relative">
					<img src="@/assets/logo_x.png" style="width:150px;" />
				</div>
				<div class="f-3">

				</div>

				<div class="f-1 relative px-3 cmt-1">
					<div class="relative f16 bolder mb-3">
						{{$t('saima.f2')}}
					</div>
					<div class="relative f10">
						{{$t('saima.f1')}}
					</div>
					<div class="relative f10 ">
						<a class="text-white" href="mailto:growth@emoka.co">growth@emoka.co</a>
					</div>
				</div>
				<div class="f-1 relative px-3 cmt-1">
					<div class="relative f16 bolder">
						{{$t('saima.f3')}}
					</div>
					<div class="relative f10 mt-3">
						<a href="https://www.instagram.com/emokaglobal" target="_blank">
							<img v-if="v=='a'" src="@/assets/f1.png" style="width: 48px;" />
							<img v-else src="@/assets/f2.png" style="width: 48px;" />
						</a>
					</div>

				</div>
			</div>

			<hr class="my-2 bg-gray" />

			<div class="relative f fx f10">
				<div class="f-1 relative">
					Copyright © 2025 EMOKA
				</div>
				<div class="f-3">

				</div>
				<div class="f-1 relative px-3">
					<!-- Terms of Use -->
				</div>
				<div class="f-1 relative px-3">
					<!-- Privacy Policy -->
				</div>
			</div>
		</div>
	</div>


</template>

<script>
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		props: ['v']
	}
</script>

<style>
	.footer {}

	hr {
		background-color: rgba(0, 0, 0, 0.2);
		height: 1px;
		/* 基础高度 1px */
		border: none;
		/* background-color: #ddd; */
		transform: scaleY(0.5);
		/* 纵向缩放为原来的 0.5 倍 */
		transform-origin: 0 0;
		/* 缩放原点（避免线条模糊） */
		/* margin: 10px 0; */
	}
</style>